           
      <div class="outside-container mt-4">
        <div class="box-container ">
            <div class="container">
                <div class="title " *ngIf="privilegesView==='VAMD'">
                  <div class="row">
                    <div class=" col-md-2  " ><div class="pointer d-flex justify-content-start "  (click)="backClick()" style="padding-left:20px;">⬅️</div></div>  
                   <div class="col-md-7 d-flex justify-content-center">Roles & Permission</div>
                   <div class=" col-md-3 row ">
                     <div class="d-flex justify-content-end">
                     <button class="btn btn-outline-primary btn-sm " (click)="onAddNew()"><img src="assets/images/Add_24.png"></button>
                   </div>
                    </div>
                  </div>
                </div> 
<div class="col-md-12 pleft-1">
  <div *ngIf="privilegesView==='AccessDenied'" class="d-flex justify-content-center">
    <img src="../../../assets/images/AccessDeniedError.png" alt="">
   </div> 
   <div *ngIf="privilegesView==='VAMD'">
<div class="row col-md-12 pleft">  
<div  class="row col-md-12 mt-2">

 
  <div class=" col-md-12  mb-4">
    <div class=" row ">
      <mat-form-field class="col-md-3 mt-1" appearance="outline">
        
         <input matInput type="text" placeholder="Search..." name="name" autocomplete="off" [(ngModel)]="searchText" (input)="onsearchText()">
       </mat-form-field>
       <mat-paginator  class="col-md-9 mt-2 " color="primary" style="background-color: transparent;"
       [pageSize]="10"
       [pageSizeOptions]="[5, 10, 25, 100]"
       [length]="totalElements"
         (page)="nextPage($event)"
       aria-label="Select page">
     </mat-paginator>
         </div>  
   
    <table mat-table [dataSource]="dataSource" style="background-color: transparent;">

           
          
      <!-- sr Column -->
      <ng-container matColumnDef="sr">
        <th mat-header-cell *matHeaderCellDef> Sr </th>
        <td mat-cell *matCellDef="let element ;let i=index"> {{i+1}} </td>
      </ng-container>
     <!-- Emp Id -->
      <ng-container matColumnDef="roleName">
          <th mat-header-cell *matHeaderCellDef> Role Name </th>
          <td mat-cell *matCellDef="let element" class="colorblue"  (click)="getRoleById(element)"> {{element.roleName}} </td>
        </ng-container>
      <!-- Name Column -->
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef> Description </th>
        <td mat-cell *matCellDef="let element"> {{element.description}} </td>
      </ng-container>
    
      <!-- email Column -->
      <ng-container matColumnDef="privileges">
        <th mat-header-cell *matHeaderCellDef> Privileges </th>
        <td mat-cell style="text-transform: capitalize;" *matCellDef="let element"> {{element.privileges}} </td>
      </ng-container>
    
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row  *matRowDef="let row; columns: displayedColumns;" ></tr>
      <tr class="mat-row" *matNoDataRow>
        <td  class="mat-cell" colspan="4">There is no data in this table</td>
      </tr>
    </table>
   
  </div>
</div>
</div>
</div>
</div>
  

<div class="modal" id="myMod" [style.display]="!islisthide ? 'block' : 'none'" >
  <div class="modal-dialog" >
      <div class="modal-content " >
          <div class="modal-header title">
            <h4 *ngIf='action==="New"' class="modal-title">Add Role</h4>
            <h4 *ngIf='action==="Update"' class="modal-title">Edit Role</h4>
            <button type="button" class="close" data-dismiss="modal" (click)="closePopup()">&times;</button>
            </div>
            <div class="modal-body">
              <div class="col-md-12 mt-3  pleft-1" *ngIf="!islisthide">

                
              <div class="col-md-12 row  d-flex justify-content-center" >
              <div class="  col-md-12  row " >
                  <div class=" col-md-12 pt-3 ">
                      <form [formGroup]="roleFg" autocomplete="off"  class=" row" (ngSubmit)="saveRole()">
          
                              <mat-form-field class=" required col-md-6 form-group " appearance="outline">
                                <mat-label>Role Name</mat-label>
                                <input matInput  type="text" required id="roleName"   name="roleName" formControlName="roleName" autocomplete="off" [(ngModel)]="roleModify.roleName">
                              </mat-form-field>
                              <mat-form-field class=" col-md-6 form-group " appearance="outline">
                                <mat-label>Description</mat-label>
                                <textarea matInput type="text"   id="description" formControlName="description"rows="1"   name="description" autocomplete="off" [(ngModel)]="roleModify.description"></textarea>
                              </mat-form-field>
                              <mat-label class="mt-2 mb-4 bold d-flex justify-content-start">Navigation Menu Access</mat-label>
                              <mat-form-field class="col-md-6 form-group " appearance="outline">
                                <mat-label>Menu</mat-label>
                                <mat-select multiple style="text-transform: capitalize;" name="menu" [(ngModel)]="selectedMenu" (selectionChange)="onMenuChange()" formControlName="menu">
                                <!--<mat-option value="all">All</mat-option>-->
                                    <mat-option style="text-transform: capitalize;"  *ngFor="let menu of menuList" [value]="menu">{{menu}}</mat-option>
                                </mat-select>
                              </mat-form-field>
                            
                              <mat-form-field class=" required col-md-6 form-group " appearance="outline">
                                <mat-label>Access</mat-label>
                                <mat-select multiple required style="text-transform: capitalize;" name="privileges" [(ngModel)]="selectedMenuPrivileges" formControlName="menuPrivileges">
                                  <mat-option style="text-transform: capitalize;"  *ngFor="let permission of menuPrivileges" [value]="permission">{{permission}}</mat-option>                 
                                </mat-select>
                              </mat-form-field>
                              <mat-label class="mt-2 mb-4 bold d-flex justify-content-start">Module Access</mat-label>
                              <mat-form-field class="  col-md-6 form-group " appearance="outline">
                                <mat-label>Module</mat-label>
                                <mat-select multiple style="text-transform: capitalize;" name="Module" [(ngModel)]="selectedModule" (selectionChange)="onModuleChange()" formControlName="module">
                                <!--<mat-option value="all">All</mat-option>-->
                                    <mat-option style="text-transform: capitalize;"  *ngFor="let module of moduleList" [value]="module">{{module}}</mat-option>
                                </mat-select>
                              </mat-form-field>
                            
                              <mat-form-field class="required col-md-6 form-group " appearance="outline">
                                <mat-label>Privileges</mat-label>
                                <mat-select multiple required style="text-transform: capitalize;" name="privileges" [(ngModel)]="selectedModulePrivileges" formControlName="modulePrivileges">
                                  <mat-option style="text-transform: capitalize;"  *ngFor="let permission of modulePrivileges" [value]="permission">{{permission}}</mat-option>                 
                                </mat-select>
                              </mat-form-field>
                              
                        </form>
                       
          
                  </div>
                  </div>
                  </div>
                  <div class="col-md-12 row mt-4" >
                    <div class="col-md-2">
                    </div>
                   
                  </div>
          </div>
              <div class="modal-footer">
                <div class="form-group form-inline ">
                  <label for="userName" class="col-md-5 col-form-label control-label"> </label>
                </div>   
                
                  <button *ngIf='action==="New"' class="btn btn-outline-primary c-width-100px  " (click)="saveRole()" [disabled]="roleFg.invalid">Add Role</button>
                  <span ><button *ngIf='action==="Update"' class="btn btn-outline-primary c-width-100px  " (click)="saveRole()" [disabled]="roleFg.invalid">Update Role</button></span>
        
                
                   <button type="button" class="btn btn-outline-primary c-width-100px shadow" data-dismiss="modal" (click)="closePopup()">Close</button>
              </div>
            </div>
            </div>
    </div>
</div>